<div class="hbox">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header"><span class="pr-3">Metabase Links</span>
        <div class="pull-right"><i class="fa fa-plus-square-o pointer" (click)="createNode()"></i></div>
      </div>
    </div>
    <div class="flex-content">
      <div class="col-xs-12 p-3">
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node *matTreeNodeDef="let node;" matTreeNodePadding>
            <div class="col-xs-12 p-1 pl-0 flex" *ngIf="hasAccessToNode(node) || node.item.get('type') === apiClientConstant.EmbeddedLink.Type.Link">
              <div class="col-xs-9 p-0">
                <i class="fas fa-link mr-2 text-muted"></i>
                <a class="clr-link" routerLink="{{node.item.id}}" target="_blank">{{node.item.get('name')}}</a>
              </div>
              <div class="col-xs-3 flex justifyFE">
                <i class="fa fa-pencil-square-o pointer ml-3" (click)="editNode(node)"></i>
              </div>
            </div>
          </mat-tree-node>
          <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
            <div class="col-xs-12 p-1 pl-0 flex" *ngIf="hasAccessToNode(node) || node.item.get('type') === apiClientConstant.EmbeddedLink.Type.Link">
              <i class="fas" 
                [class.fa-folder]="!treeControl.isExpanded(node)" 
                [class.fa-folder-open]="treeControl.isExpanded(node)" 
                matTreeNodeToggle 
                [attr.aria-label]="'toggle ' + node.item">
              </i>
              <div class="col-xs-6 flex alignC gap-12 fontL1 bold">{{node.item.get('name')}}
                <span class="badge bg-secondary" *ngFor="let role of node.item.get('allowedRoles')">{{role.get('name')}}</span>
              </div>
              <div class="col-xs-3">
                <mat-progress-bar class="ml-3" *ngIf="node.isLoading" mode="query"></mat-progress-bar>
              </div>
              <div class="col-xs-3 flex justifyFE">
                <i class="fa fa-pencil-square-o pointer ml-3" (click)="editNode(node)"></i>
                <i class="fa fa-plus-square-o pointer ml-3" (click)="createNode(node)"></i>
              </div>
            </div>
          </mat-tree-node>
        </mat-tree>
      </div>
    </div>
  </div>
</div>